module.exports = __webpack_public_path__ + "img/file-wrapper.c93f543b.svg";